<ul class="nav nav-tabs">
    <li class="nav-item pe-2">
        <a class="nav-link active" aria-current="page">Tours / Viajes</a>
    </li>
</ul>
<div class="row">
    <div class="col-12 mt-4">
        <form [formGroup]="form" (ngSubmit)="onSubmit()"  class="login">
            <div class="form-control p-0 position-relative">
                <input type="search" formControlName="search" class="w-100 border-secondary" placeholder="Buscar por destino, nombre o mes">
                <input type="image" src="../assets/images/body/icons/search-icon.svg" class="position-absolute search-icon" style="border: 0px; padding: 0px;"  alt="Buscar" />  
            </div>
        </form>
    </div>
    <!-- <div class="col-12 mt-4 d-flex">
        <div class="text-secondary rounded-pill border border-2 me-3 border-secondary btn-md btn-outline">
            Destino
        </div>
    </div> -->
</div>
<h4 class="title-bg mt-4">Viajes Publicados</h4>
<div class="row mt-4">
    <div *ngFor="let item of listViajes" class="tour-card" >
        <div class="tour-wrapper">
            <ng-template
                *ngIf="item.imagen; then imgRecibida; else imgDefault">
            </ng-template>
            <ng-template #imgRecibida>
                <div class="tour-img">
                    <img src={{item.imagen}} class="img-responsive" alt="">
                </div>
            </ng-template>
                <ng-template #imgDefault>
                    <div class="tour-img">
                        <img src="../assets/images/body/tours/5.jpg" class="img-responsive" alt="">
                    </div>
                </ng-template>                     
            <div class="tour-content">
                <h5 class="mb-3 mt-3 text-center">{{item.paquete.nombre_paquete}}</h5>                
                <a [routerLink]="['/','admin', 'tours-update',item.paquete.id]" class="btn btn-lg rounded-pill btn-primary text-white text-center btn-reservar align-self-center">Modificar viaje</a>
                <a style="cursor: pointer;" (click)="cancelar(item.paquete.id)" class="mt-4 btn btn-lg rounded-pill btn-primary text-white text-center btn-reservar align-self-center">Cancelar viaje</a>
            </div>
        </div>
    </div>
</div>
